<template>
  <transition name="cycleFromLeft" mode="out-in">
    <div class="productCart vh-for-mobile"
         :data-variant="variant">

      <div class="wrapper">
        <div class="productCart__shortText"
             v-html="config.shortText"></div>

        <div class="productCart__fullText"
             v-html="config.fullText"></div>

        <div class="productCart__item">
          <div class="productCart__item__img">
            <img v-if="config.product && config.product.ImageURL"
                 :src="config.product.ImageURL"
                 :alt="config.product.Product_Name"/>
          </div>
          <div class="productCart__item__content">
            <div v-if="config.product && config.product.Manufacturer"
                 class="productCart__item__brand">{{config.product.Manufacturer}}
            </div>
            <div v-if="config.product && config.product.Category_4"
                 class="productCart__item__model">{{config.product.Category_4}}
            </div>
            <div v-if="config.product && config.product.Product_Name"
                 class="productCart__item__description">{{config.product.Product_Name}}
            </div>
            <div v-if="config.product && config.product.delivery"
                 class="productCart__item__delivery">
              <img src="https://placehold.it/50x50" alt=""/>
              <span>Consegna gratuita</span>
            </div>
            <div v-if="config.product && config.product.Price"
                 class="productCart__item__price">&euro; {{config.product.Price}}
            </div>
          </div>
        </div>

        <div class="productCart__buttons">
          <div v-for="item in config.answers"
               class="productCart__next"
               @click="retrieveNextStep(config.id, item.id, item.disabled)">
            <a class="productCart__next__link" v-if="item.link" :href="item.link.url" :target="item.link.target">{{item.text}}</a>
            <span class="productCart__next__span" v-else>{{item.text}}</span>
            <img :src="item.icon" alt=""/>
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
  export default{
    props: ['dataObj', 'currentVariant'],
    data(){
      return {
        config: {},
        variant: this.currentVariant,
        hasInfo: false
      }
    },
    watch: {
      currentVariant(){
        this.variant = this.currentVariant;
      }
    },
    methods: {
      checkIfOverflow(){
        var viewHeight = $('.productCart').innerHeight();
        var windowHeight = $(window).innerHeight();
        var footerHeight = $('.footer').innerHeight();
        var headerHeight = $('.header').innerHeight();
        var visibleHeight = windowHeight - footerHeight - headerHeight;
        if (viewHeight > visibleHeight) {
          $('.productCart').addClass('has-overflow');
        }
      },
      toggleFilter(filter){
        var filterBlock = $('.productListing__filter--' + filter);
        var filterContent = filterBlock.find('.productListing__filter__content');
        filterContent.toggleClass('is-open');
      },
      closeInfoBox(){
        $('.productListing__info').hide();
      },
      updateProps(){
        //Update component data when component is mounted or updated
        this.config = this.dataObj;
      },
      updateParentProps(){
        // Emits response from @retrieveNextStep(), precedently saved in Vue store, to parent component @App.vue
        var vm = this;
        var config = vm.$store.state.tempConfigObj;
        if (config) {
          vm.$emit('update-props', config);
          this.$forceUpdate();
        }
      },
      retrieveNextStep(questionId, answerId, isDisabled){
        if (!isDisabled) {
          // Make AJAX call to retrieve next summary node
          // @summaryId {integer}:
          //    is the current node ID
          // @answerId {integer}:
          //    is the chosen answer ID
          var vm = this;
          for (var i = 0; i < vm.config.answers.length; i++) {
            vm.config.answers[i].disabled = true;
          }
          vm.makeNextCall(questionId, answerId, function () {
            vm.updateParentProps();
          })
        }
      }
    },
    mounted(){
      var vm = this;
      vm.updateProps();
      setTimeout(function () {
        vm.checkIfOverflow();
      }, 1001);
    },
    updated(){
      var vm = this;
      vm.updateProps();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ecommerce/ProductCart.vue